<template>
  <div class="footer-container">
    <p class="friends">
      <span>友情链接:</span>
      <a
        v-for="item in friends"
        :key="item.link"
        :href="item.link"
        target="_blank"
        >{{ item.name }}</a
      >
    </p>
    <p>
      © {{ new Date().getFullYear() }} - {{ system.title }} -
      <a href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备17003103号</a>
    </p>
    <p>
      Powered by Yuan Jin
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("system", ["system"]),
    friends() {
      const arr = JSON.parse(this.system.friendLinksJson);
      arr.sort((a, b) => a.order - b.order);
      return arr;
    }
  }
};
</script>
